import React, { useRef, useState } from "react";
import CustomSelect from "../select";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button, CloseButton, CloseButtonDiv, FileContainer, Info, Input, InputContainer, InputContainer2, Label, LabelTop, TextArea } from "./styles";
import { ErrorMessage } from "../form/styles";
import { GetIcon, TickIcon, UploadIcon } from "../../../icons";
import Checkbox from "../checkbox";
import MultiSelect from "../multiSelect";
import { DateTimePicker } from "../datepicker";
import { useLocation } from "react-router-dom";
import { germany, inernational } from "../../../images";
import { RiArrowDropDownLine } from "react-icons/ri";

function FormInput(props) {
  // Initialize translation function for current language
  const { t } = useTranslation();
  // Create a reference to file input element
  const fileInputRef = useRef(null);
  const location = useLocation();
// console.log(props.name, props.value);
  // Get theme colors from Redux store
  const themeColors = useSelector((state) => state.themeColors);
  // const formatDateTime = (type, value) => {
  //   const today = moment().startOf("day");
  //   const tomorrow = moment().startOf("day").add(1, "days");
  //   const date = moment(value);

  //   if (type === "datetime") {
  //     return date.format("DD.MM.YYYY, H:mm");
  //   } else if (type === "date") {
  //     if (date.isSame(today, "day")) {
  //       return "Today";
  //     } else if (date.isSame(tomorrow, "day")) {
  //       return "Tomorrow";
  //     } else {
  //       return date.format("DD. MM.YYYY");
  //     }
  //   }
  // };

  const [isGerman, setIsGerman] = useState(true);
  const [isGermanOpen, setIsGermanOpen] = useState(false);
  const selectRef = useRef(null);

  const handleRadioChange = async (status) => {
    setIsGerman(status);
    setIsGermanOpen(false);
  };

  console.log(props.type, props.name, props.disabled, props.value);

  switch (props.type) {
    // Render a regular text input
    case "text":
    case "password":
    case "email":
    case "color":
      return (
        <div style={{flex: props.customClass==="full" ? "100%" : "calc(50% - 10px)", display: props.dynamicClass==="disabled"?"none":""}}>
          <LabelTop className={`${props.textWrap ?? ""}`} theme={themeColors} >
            {`${t(props.label)}${props.required ? " *" : ""}`}
          </LabelTop>
        <InputContainer className={`${props.dynamicClass ?? ""}`} animation={props.animation}>
          {/* {props.error?.length ? (
            <Label theme={themeColors} className={`${!props.value?.length > 0 ? "error shrink" : "error"}`}>
              {props.error}
            </Label>
          ) : (
            <Label theme={themeColors} className={`${!props.value?.length > 0 ? "shrink" : ""}`}>
              <TickIcon />
              {`${t(props.label)}${props.required ? " *" : ""}`}
            </Label>
          )} */}
          <Input disabled={props.disabled || false} autoComplete="on" theme={themeColors} className={`input ${props.value?.length > 0 ? "shrink" : ""}`} 
          // placeholder={`${props.formType === "put" ? "" : t(props.placeholder)}`} 
          type={props.type} value={props.value} onChange={(event) => {props?.onChange(props.index??0, event, props.id, props.type, props.sub)}} />
          {props.error?.length > 0 && <ErrorMessage dangerouslySetInnerHTML={{ __html: props?.error }}></ErrorMessage>}
        </InputContainer>
        </div>
      );
    // Render a time input with time picker
    case "number":
      const value = isNaN(props.value) ? null : props.value;
      const handleKeyDown = (event) => {
        if (event.keyCode === 38 || event.keyCode === 40) {
          // Prevent the default behavior for up and down arrow keys
          event.preventDefault();
        }
      };
      return (
        <div style={{flex: props.customClass==="full" ? "100%" : "calc(50% - 10px)", display: props.dynamicClass==="disabled"?"none":""}}>
          <LabelTop className={`${props.textWrap ?? ""}`} theme={themeColors} >
            {`${t(props.label)}${props.required ? " *" : ""}`}
          </LabelTop>
        <InputContainer className={`${props.dynamicClass ?? ""} ${props.countryCode ? 'country' : ''}`} animation={props.animation}>
          {/* {props.error?.length ? (
            <Label theme={themeColors} className={`${!value?.toString().length > 0 ? "error shrink" : "error"}`}>
              {props.error}
            </Label>
          ) : (
            <Label theme={themeColors} className={`${!value?.toString().length > 0 ? "shrink" : ""}`}>
              <TickIcon />
              {`${t(props.label)}${props.required ? " *" : ""}`}
            </Label>
          )} */}
          {props.countryCode === true && <InputContainer2 className="radio" ref={selectRef}>
                      <div 
                        onClick={() => {
                          setIsGermanOpen(!isGermanOpen);
                        }}
                        className="label"
                      >
                        {isGerman ? <img src={germany} alt="Germany"></img> : <img src={inernational} alt="Germany"></img>}
                        <span style={{marginLeft:'4px',display:"flex",alignItems:"center"}} ><RiArrowDropDownLine fontSize={25} /></span>
                      </div>
                      {isGermanOpen && (
                        <div className="absolute">
                          <input id="germamy" type="radio" name="isGermany" onChange={() => handleRadioChange(true)} checked={isGerman}></input>
                          <label htmlFor="germamy">
                            <img src={germany} alt="Germany"></img>
                            <span>{t("germany")}</span>
                          </label>
                          <input id="foreign" type="radio" name="isGermany" onChange={() => handleRadioChange(false)} checked={!isGerman}></input>
                          <label htmlFor="foreign">
                            <img src={inernational} alt="Germany"></img>
                            <span>{t("foreign")}</span>
                          </label>
                        </div>
                      )}
                </InputContainer2>}
          <Input
            onKeyDown={handleKeyDown} // Attach the onKeyDown event handler
            onWheel={(e) => e.target.blur()}
            autoComplete="on"
            theme={themeColors}
            className={`input ${value?.toString().length > 0 ? "shrink" : ""} ${props.countryCode ? 'country' : ''}`}
            // placeholder={`${props.formType === "put" ? "" : t(props.placeholder)}`}
            type={props.type}
            value={value}
            onChange={(event) => props.onChange(props.index, event, props.id, props.type, props.sub)}
            min={props.minimum || 0}
            max={props.maximum}
            disabled={props.disabled || false}
          />
          {props.error?.length > 0 && <ErrorMessage dangerouslySetInnerHTML={{ __html: props.error }}></ErrorMessage>}
        </InputContainer>
        </div>
      );
    // Render a time input with time picker
    case "time":
      let userFriendlyTime = props.value?.length > 0 ? new Date(props.value) : null;
      return (
        <div style={{flex: props.customClass==="full" ? "100%" : props.customClass==="quarter" ? "calc(25% - 10px)" : "calc(50% - 10px)", display: props.dynamicClass==="disabled"?"none":""}}>
          <LabelTop className={`${props.textWrap ?? ""}`} theme={themeColors} >
            {`${t(props.label)}${props.required ? " *" : ""}`}
          </LabelTop>
        <InputContainer className={`${props.dynamicClass ?? ""}`}>
          <DateTimePicker disabled={props.disabled || false} placeholderText={t("HH:mm")} theme={themeColors} showTimeSelect showTimeSelectOnly timeIntervals={props.interval ?? 1} timeFormat="HH:mm" timeCaption="Time" selected={userFriendlyTime} dateFormat="HH:mm" className={`input time`} type={props.type} onChange={(event) => props.onChange(props.index, event, props.id, props.type)} />
          {/* {props.error?.length ? (
            <Label theme={themeColors} className={`${!props.value?.length > 0 ? "error shrink" : "error"}`}>
              {props.error}
            </Label>
          ) : (
            <Label theme={themeColors} className={`${!props.value?.length > 0 ? "shrink" : ""}`}>
              <TickIcon />
              {`${t(props.label)}${props.required ? " *" : ""}`}
            </Label>
          )} */}
          {props.error?.length > 0 && <ErrorMessage dangerouslySetInnerHTML={{ __html: props.error }}></ErrorMessage>}
        </InputContainer>
        </div>
      );
    // Render a date input with date picker
    case "date":
      let userFriendlyDate = props.value?.length > 0 ? new Date(props.value) : null;
      return (
        <div style={{flex: props.customClass==="full" ? "100%" : props.customClass==="quarter" ? "calc(25% - 10px)" : "calc(50% - 10px)", display: props.dynamicClass==="disabled"?"none":""}}>
          <LabelTop className={`${props.textWrap ?? ""}`} theme={themeColors} >
            {`${t(props.label)}${props.required ? " *" : ""}`}
          </LabelTop>
        <InputContainer className={`${props.dynamicClass ?? ""}`}>
          {!props.required && userFriendlyDate && userFriendlyDate!==null && !props.disabled &&(
            <CloseButton onClick={(event) => props.onChange(props.index, null, props.id, props.type)}>
              <GetIcon icon={"close"}></GetIcon>
            </CloseButton>
          )}
          <DateTimePicker disabled={props.disabled || false} placeholderText={t("DD.MM.YYYY")} minDate={props.minDate ? new Date(props.minDate) : null} maxDate={props.maxDate ? new Date(props.maxDate) : null} theme={themeColors} className={`input`} dateFormat={"dd.MM.yyyy"} type={props.type} selected={userFriendlyDate} onChange={(event) => props.onChange(props.index, event, props.id, props.type)} />
          {/* {props.error?.length ? (
            <Label theme={themeColors} className={`${!props.value?.length > 0 ? "error shrink" : "error"}`}>
              {props.error}
            </Label>
          ) : (
            <Label theme={themeColors} className={`${!props.value?.length > 0 ? "shrink" : ""}`}>
              <TickIcon />
              {`${t(props.label)}${props.required ? " *" : ""}`}
            </Label>
          )} */}
          {props.error?.length > 0 && <ErrorMessage dangerouslySetInnerHTML={{ __html: props.error }}></ErrorMessage>}
        </InputContainer>
        </div>
      );
    // Render a datetime input with date and time pickers
    case "datetime":
      let userFriendlyDateTime = props.value?.length > 0 ? new Date(props.value) : null;
      return (
        <div style={{flex: props.customClass==="full" ? "100%" : props.customClass==="quarter" ? "calc(25% - 10px)" : "calc(50% - 10px)", display: props.dynamicClass==="disabled"?"none":""}}>
          <LabelTop className={`${props.textWrap ?? ""}`} theme={themeColors} >
            {`${t(props.label)}${props.required ? " *" : ""}`}
          </LabelTop>
        <InputContainer className={props.half && "half"}>
          {!props.required && userFriendlyDateTime && userFriendlyDateTime!==null && !props.disabled && (
            <CloseButton onClick={(event) => props.onChange(props.index, null, props.id, props.type)}>
              <GetIcon icon={"close"}></GetIcon>
            </CloseButton>
          )}
          <DateTimePicker disabled={props.disabled || false} theme={themeColors} showTimeSelect timeIntervals={props.interval ?? 1} timeFormat="HH:mm" dateFormat={"dd.MM.yyyy HH:mm"} className={`input`} placeholderText={`${t("DD.MM.YYYY")} ${t("HH:mm")}`} type={props.type} value={userFriendlyDateTime} selected={userFriendlyDateTime} onChange={(event) => props.onChange(props.index, event, props.id, props.type)} />
          {/* {props.error?.length ? (
            <>
              <Label theme={themeColors} className={`${!props.value?.length > 0 ? "error shrink" : "error"}`}>
                {`${props.error}`}
              </Label>
            </>
          ) : (
            <>
              <Label theme={themeColors} className={`${!props.value?.length > 0 ? "shrink" : ""}`}>
                <TickIcon />
                {`${t(props.label)}${props.required ? " *" : ""}`}
              </Label>
            </>
          )} */}
        </InputContainer>
        </div>
      );
    // Render a file and image
    case "image":
    case "file":
      function formatSize(sizeInBytes) {
        if (sizeInBytes < 1024) {
          return sizeInBytes + " bytes";
        } else if (sizeInBytes < 1024 * 1024) {
          return (sizeInBytes / 1024).toFixed(2) + " KB";
        } else {
          return (sizeInBytes / (1024 * 1024)).toFixed(2) + " MB";
        }
      }
      const size = formatSize((props.value?.length > 0 && props.value[0]) ? props.value[0]?.size : 0);
      const handleButtonClick = () => {
        fileInputRef.current.click();
      };
      return (
        <FileContainer theme={themeColors}>
          <button onClick={handleButtonClick}>
            <UploadIcon />
            {t("upload", { label: t(props.label) }) + (props.required ? " *" : "") + (props.value?.length > 0 ? ` : ${props.value[0]?.name} (${size})` : "")}
          </button>
          <Input disabled={props.disabled || false} ref={fileInputRef} style={{ display: "none" }} theme={themeColors} accept={props.type === "image" ? `image/*` : ``} className={`input ${props.value?.length > 0 ? "shrink" : ""}`} placeholder={props.formType === "put" ? "" : t(props.placeholder)} type={`file`} onChange={(event) => props.onChange(props.index, event, props.id, props.type)} />
          {props.error?.length > 0 && <ErrorMessage dangerouslySetInnerHTML={{ __html: props.error }} />}
        </FileContainer>
      );
    // Render a textarea
    case "textarea":
      return (
        <div style={{flex: "calc(100% - 10px)", display: props.dynamicClass==="disabled"?"none":""}}>
          <LabelTop className={`${props.textWrap ?? ""}`} theme={themeColors} >
            {`${t(props.label)}${props.required ? " *" : ""}`}
          </LabelTop>
        <InputContainer className="textarea">
          {/* {props.error?.length ? (
            <Label theme={themeColors} className={`${!props.value?.length > 0 ? "error shrink" : "error"}`}>
              {props.error}
            </Label>
          ) : (
            <Label theme={themeColors} className={`${!props.value?.length > 0 ? "shrink" : ""}`}>
              <TickIcon />
              {`${t(props.label)}${props.required ? " *" : ""}`}
            </Label>
          )} */}
          <TextArea disabled={props.disabled || false} theme={themeColors} className={`input ${props.value?.length > 0 ? "shrink" : ""} ${props.login ?? ""} `} 
          // placeholder={`${props.formType === "put" ? "" : t(props.placeholder)}`} 
          value={props.value} onChange={(event) => props.onChange(props.index, event, props.id)} />
        </InputContainer>
        </div>
      );
    // Render a submit button
    case "submit":
      return (
        <Button  style={{width: location.pathname==='/' || location.pathname==='/signup'?'100%':''}} theme={themeColors} className={`submit ${props.login ?? ""}`} disabled={props.disabled} type={props.type} onClick={props.onChange}>
          {props.value}
        </Button>
      );
    // Render a close button
    case "close":
      return (
        <CloseButtonDiv theme={themeColors} className="close" type={props.type} onClick={props.onChange}>
          {props.value}
        </CloseButtonDiv>
      );
    // Render a cehckbox
    case "checkbox":
      return (
        <InputContainer style={{flex: props.customClass==="full" ? "100%" : props.customClass==="quarter" ? "calc(25% - 10px)" : "auto"}} className={`checkbox ${props.dynamicClass ?? ""}`}>
          <Label className={`checkbox ${props.login ?? ""}`}>
            <Checkbox
            className={`${props.login ?? ""}`}
              theme={themeColors}
              label={t(props.placeholder)}
              type={props.type}
              checked={props.value}
              onChange={(event) => {
                // console.log(event.target.checked === false ? false : true);
                props.onChange(0,event.target.checked === false ? false : true, props.id, props.type);
              }}
            ></Checkbox>
            {/* <span dangerouslySetInnerHTML={{ __html: t(props.placeholder) }}></span> */}
          </Label>
        </InputContainer>
      );
    // Render a select box
    case "select":
      return <CustomSelect bulkUpload={props.bulkUpload ?? false} theme={themeColors} {...props} name={props.id} selected={props.value} onSelect={props.onChange}></CustomSelect>;
    case "info":
      return <Info className={` ${props.dynamicClass}`}>{t(props.content ?? "")}</Info>;
    case "title":
      return <Info className={`title ${props.dynamicClass}`}>{t(props.title ?? "")}</Info>;
    case "multiSelect":
      return (
          <MultiSelect dynamicClass={props.dynamicClass} theme={themeColors} {...props} name={props.id} selected={props.value} onSelect={props.onChange}></MultiSelect>
      );
    case "hidden":
      return <Input disabled={props.disabled ?? false} autoComplete="on" theme={themeColors} className={`input ${props.value.toString().length > 0 ? "shrink" : ""}`} 
      // placeholder={`${props.formType === "put" ? "" : t(props.placeholder)}`} 
      type={props.type} value={props.value} onChange={(event) => props.onChange(0,event, props.id, props.type, props.sub)} />;

    default:
      return <></>;
  }
}
export default FormInput;
